export default __webpack_public_path__ + "static/media/bg-home-mob.c0b5aa0d.png";